import { render, staticRenderFns } from "./params-edit.vue?vue&type=template&id=ad4328f2&"
import script from "./params-edit.vue?vue&type=script&lang=ts&"
export * from "./params-edit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports